import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "ab-show-aggregations-callout",
  templateUrl: "./show-aggregations-callout.component.html",
})
export class ShowAggregationsCalloutComponent {
  @Input() public group: any;
  @Output() public dismiss = new EventEmitter<void>();

  public dismissCallout() {
    // TODO: [onboarding] ideally also tell the group list to activateGroup to
    // this one, so our ui-sref does not have to reload:true.
    this.dismiss.emit();
  }
}
